<template>
  <div id="listVersoes">
    <v-layout v-resize="onResize" style="display:flex;flex-flow: column;">
      <v-sheet style="margin-right: 25px;">
        <v-switch
          @change="findData()"
          v-model="exibirObsoletos"
          inset
          color="#2A5377"
          :label="`Exibir versões obsoletas`"
        ></v-switch>
      </v-sheet>    
      <v-container
        v-if="loadinData"
        style="height: 400px;display: flex;margin-top:150px; justify-content: center;"
      >
        <v-row class="fill-height" align-content="center" justify="center">
          <v-col class="subtitle-1 text-center" cols="12">Baixando dados..</v-col>
          <v-col cols="6">
            <v-progress-linear color="#88C658" indeterminate rounded height="6"></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
      <div v-else>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Pesquisar"
          single-line
          hide-details
        ></v-text-field>
        <v-data-table
          :headers="headers"
          rows-per-page-text="Items por página"
          :items="arquivosArr"
          :hide-headers="isMobile"
          :class="{mobile: isMobile}"
          item-key="VERVERSAOINTERNA"
          :pagination.sync="pagination"
          no-data-text="Nada foi encontrado."
          no-results-text="Nada foi encontrado."
          :search="search"
          style="width: 100%!important;"
          :sort-by="['VERESTADO', 'SISCODIGO']"
          :sort-desc="[false, true]"
          multi-sort
          :rows-per-page-items="[
              {
                text: '100',
                value: 100
              },
              {
                text: '300',
                value: 300
              },
              {
                text: '500',
                value: 500
              },
              {
                text: 'Todos',
                value: -1
              }
            ]"
        >
          <template v-slot:items="props">
            <tr v-if="!isMobile">
              <td @click="props.expanded = !props.expanded">
                <md-icon :style="'color: ' + getStyleColor(props.item.VERESTADO)">{{getEstadoIcon(props.item.VERESTADO)}}</md-icon>
                <md-tooltip md-delay="800">{{getEstadoText(props.item.VERESTADO)}}</md-tooltip>
              </td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.SISDESCRICAO || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.VERVERSAOSETUP || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.VERVERSAOINTERNA || "---" }}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.VERDATASETUP | formatDateNormal}}</td>
              <td
                class="text-xs-left"
                @click="props.expanded = !props.expanded"
              >{{ props.item.VERDATALIBERACAO | formatDateNormal}}</td>              
            </tr>
            <tr v-else>
              <td style="margin-bottom:25px">
                <ul class="flex-content">
                  <li class="flex-item" data-label="Produto:">{{ props.item.SISDESCRICAO }}</li>
                  <li class="flex-item" data-label="Versão:">{{ props.item.VERVERSAOSETUP }}</li>
                  <li class="flex-item" data-label="Versão Interna:">{{ props.item.VERVERSAOINTERNA }}</li>
                  <li class="flex-item" data-label="Data Setup:">{{ props.item.VERDATASETUP }}</li>
                  <li class="flex-item" data-label="Liberação:">{{ props.item.VERDATALIBERACAO }}</li>
                </ul>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <v-alert
              :value="true"
              color="error"
              icon="warning"
              style="color: #000!important"
            >Nada foi encontrado.</v-alert>
          </template>

          <template v-slot:expand="props" v-if="!isMobile">
            <DetalhesVersao :versao="props.item" />
          </template>

          <template
            slot="pageText"
            slot-scope="item"
          >Exibindo {{item.pageStart}} - {{item.pageStop}}, Total {{item.itemsLength}}</template>
        </v-data-table>
      </div>
    </v-layout>

    <md-snackbar :md-active.sync="empSaved">Sucesso!</md-snackbar>
    <md-snackbar :md-active.sync="errorSaved">Erro interno do servidor</md-snackbar>
    <md-snackbar :md-active.sync="msg">{{msg}}</md-snackbar>
  </div>
</template>
<script>
import * as Versoes from "../../providers/versoes.service";
import DetalhesVersao from "./detalhesVersao";

var jwt = require("jsonwebtoken");

export default {
  name: "tabela-clientes",
  components: {
    Map,
    DetalhesVersao
  },
  data() {
    return {
      isMobile: false,
      search: "",
      loadinData: true,
      loading5: false,
      endereco: false,
      coords: false,
      msg: false,
      exibirObsoletos: false,
      pagination: { rowsPerPage: 100 },
      activemap: false,
      errorSaved: false,
      empSaved: false,
      arquivosArr: [],
      headers: [
        {
          value: "VERESTADO"
        },
        {
          text: "Produto",
          value: "SISCODIGO"
        },
        {
          text: "Versão",
          value: "VERVERSAOSETUP"
        },
        {
          text: "Versão Interna",
          value: "VERVERSAOINTERNA"
        },       
        {
          text: "Data Setup",
          value: "VERDATASETUP"
        },
        {
          text: "Liberação",
          value: "VERDATALIBERACAO"
        }
      ],
      desserts: []
    };
  },

  methods: {    
    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    },
    mapclosed() {
      this.activemap = false;
      this.coords = false;
      this.endereco = false;
    },
    findData() {
      var self = this;
      var fFilter = '';

      if (self.exibirObsoletos == false)
        fFilter = 'VERESTADO != 3';

      var fUser = jwt.decode(localStorage.getItem("token"));
  
      Versoes.getVersoes(fUser.SEGCODIGO, fFilter).then(resp => {
        self.arquivosArr = resp;
        self.loadinData = false;
      });
    },
    getStyleColor(estado) {
      switch (estado) {
        case 0: return "#00cc66";
        case 1: return "#dddd44";
        case 2: return "#ffaa66";
        case 3: return "#ff6666";
        default: return "#606060";
      }
    },
    getEstadoIcon(estado) {
      switch (estado) {
        case 0: return "verified";
        case 1: return "build_circle";
        case 2: return "brightness_auto";
        case 3: return "do_disturb_on";
        default: return "";
      }
    },
    getEstadoText(estado) {
      switch (estado) {
        case 0: return "Estável";
        case 1: return "Beta";
        case 2: return "Alfa";
        case 3: return "Obsoleto";
        default: return "";
      }
    }
  },
  created() {
    var self = this;
    self.exibirObsoletos = false;
    self.findData();
  }
};
</script>
<style scoped>
.copy {
  position: relative;
}
.copy .iconcopy {
  opacity: 0;
  position: absolute;
  color: rgb(97, 97, 97);
  top: 0;
}
.copy:hover .iconcopy {
  opacity: 1;
  cursor: pointer;
}
li {
  min-height: 58px;
}
.iconedit {
  font-size: 15px !important;
  position: absolute;
  top: 5px;
  right: 5px;
  opacity: 0;
  cursor: pointer;
}
.descarrude:hover .iconedit {
  opacity: 1;
}
.iconedit:hover {
  font-size: 16px !important;
  position: absolute;
  color: #000 !important;
  top: 5px;
}
</style>
<style>
#listAarquios .v-datatable__actions__select {
  opacity: 0;
  display: none !important;
}
</style>